@file:Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")

package com.schoolconnect.app.util

expect object BuildConfig {
    fun isDebug(): Boolean
    fun isServerApp(): Boolean
    fun platform(): PlatformType
    fun getVersion(): String
    fun userAgent(): PlatformType
}

sealed class PlatformType {
    data object ANDROID : PlatformType()
    data object IOS : PlatformType()
    data object DESKTOP : PlatformType()
    data object JS : PlatformType()
    data object WASM : PlatformType()
}

fun String.value(): String {
    val value = StringBuilder()
    for (element in this) {
        val valueChar = (element.code - 9999).toChar()
        value.append(valueChar)
    }
    return value.toString()
}
